import { ChipVariant } from 'src/app/domain/enums/components/chip.enum'
import { DomainIdentity } from '../erp/administrator/domain-identity.model'
import { Permission } from '../erp/administrator/permission.model'

export class AuthUserCompany {
  fantasy: string
  label: string
  value: number
  cnpj: string
  branches: Array<any>
  parentId: number | null
  mandatorySegment: boolean
  permissions: Array<Permission>
  modules: Array<number>
  taskStatus: Array<string>
  socialReason: string
  taxRegimeDescription: string
  address: string
  phone: string
  stateRegistration: string | null
  municipalRegistration: string | null
  mandatoryCostCenterRegistration: boolean | null
  movementNegativeStock: boolean
  stockGroup: boolean
  allowMultipleCostCenterProject: boolean
  deleteBaseIcmsPisCofins: boolean
  deletePurchaseBaseIcmsPisCofins: boolean
  issRequired: boolean
  industrialEstablishmentClassification: number | null
  zipCode: string
  ufId: number | null
  cityId: number | null
  cityCode: string | null
  complement: string | null
  district: string | null
  number: string | null
  taxRegimeId: number | null
  taskParameterActive: boolean
  mainDomain: DomainIdentity
  nfsIntegrationOk: boolean
  nfsIntegrationLabel: string
  nfsIntegrationChipVariant: ChipVariant
  nfceHabilitado: boolean
  nfceIntegrationLabel: string
  nfceIntegrationChipVariant: ChipVariant
  nfeIntegrationOk: boolean
  nfeIntegrationLabel: string
  nfeIntegrationChipVariant: ChipVariant
  nfeIntegrationTooltip: string
  constructionContractor: boolean
  email: string
  billingGroupCompanyIds: Array<number>
  bankIntegrations: Array<{ companyAccountId: number; code: string }>

  constructor(option?: AuthUserCompany) {
    this.value = option?.value ?? 0
    this.label = option?.label ?? ''
    this.branches = option?.branches ?? new Array()
    this.parentId = option?.parentId ?? null
    this.permissions = option?.permissions ?? new Array()
    this.modules = option?.modules ?? new Array()
    this.taskStatus = option?.taskStatus ?? new Array()
    this.cnpj = option?.cnpj ?? ''
    this.fantasy = option?.fantasy ?? ''
    this.socialReason = option?.socialReason ?? ''
    this.taxRegimeDescription = option?.taxRegimeDescription ?? ''
    this.address = option?.address ?? ''
    this.phone = option?.phone ?? ''
    this.stateRegistration = option?.stateRegistration ?? ''
    this.municipalRegistration = option?.municipalRegistration ?? ''
    this.mandatorySegment = option?.mandatorySegment ?? false
    this.mandatoryCostCenterRegistration = option?.mandatoryCostCenterRegistration ?? false
    this.movementNegativeStock = option?.movementNegativeStock ?? false
    this.stockGroup = option?.stockGroup ?? false
    this.allowMultipleCostCenterProject = option?.allowMultipleCostCenterProject ?? false
    this.deleteBaseIcmsPisCofins = option?.deleteBaseIcmsPisCofins ?? false
    this.deletePurchaseBaseIcmsPisCofins = option?.deletePurchaseBaseIcmsPisCofins ?? false
    this.issRequired = option?.issRequired ?? false
    this.industrialEstablishmentClassification = option?.industrialEstablishmentClassification ?? null
    this.zipCode = option?.zipCode ?? ''
    this.ufId = option?.ufId ?? null
    this.cityId = option?.cityId ?? null
    this.cityCode = option?.cityCode ?? null
    this.complement = option?.complement ?? null
    this.district = option?.district ?? null
    this.number = option?.number ?? null
    this.taxRegimeId = option?.taxRegimeId ?? null
    this.taskParameterActive = option?.taskParameterActive ?? false
    this.mainDomain = option?.mainDomain ?? new DomainIdentity()
    this.nfsIntegrationOk = option?.nfsIntegrationOk ?? false
    this.nfsIntegrationLabel = option?.nfsIntegrationOk ? 'Configurado' : 'Pendente'
    this.nfsIntegrationChipVariant = option?.nfsIntegrationOk ? ChipVariant.POSITIVE_DARK : ChipVariant.WARNING
    this.nfceHabilitado = option?.nfceHabilitado ?? false
    this.nfceIntegrationLabel = option?.nfceHabilitado ? 'Configurado' : 'Pendente'
    this.nfceIntegrationChipVariant = option?.nfceHabilitado ? ChipVariant.POSITIVE_DARK : ChipVariant.WARNING
    this.nfeIntegrationOk = option?.nfeIntegrationOk ?? false
    this.nfeIntegrationLabel = option?.nfeIntegrationOk ? 'Configurado' : 'Pendente'
    this.nfeIntegrationChipVariant = option?.nfeIntegrationOk ? ChipVariant.POSITIVE_DARK : ChipVariant.WARNING
    this.nfeIntegrationTooltip = option?.nfeIntegrationOk ? (option?.nfeIntegrationTooltip ?? '') : ''
    this.constructionContractor = option?.constructionContractor ?? false
    this.email = option?.email ?? ''
    this.billingGroupCompanyIds = option?.billingGroupCompanyIds ?? new Array()
    this.bankIntegrations = option?.bankIntegrations ?? new Array()
  }
}
